import { useNetworkStatus } from 'hooks/useNetworkStatus';

function NetworkStatusNotifier() {
  useNetworkStatus();
  return null;
}

export default NetworkStatusNotifier;
